export type PostStreamReport = {
  id: string;
  stream_session_id: string;
  status: string;
  summary: string;
  significant_failures: unknown[];
  automatic_recoveries: unknown[];
  unresolved_incidents: unknown[];
  totals: {
    unresolvedIncidents?: number;
    automaticRecoveries?: number;
    failedAlerts?: number;
    failedAudio?: number;
    [key: string]: unknown;
  };
  created_at?: string;
};

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      ...(init?.body === undefined ? {} : { 'Content-Type': 'application/json' }),
      ...(init?.headers ?? {}),
    },
  });
  if (!response.ok) {
    const body = (await response.json().catch(() => ({}))) as { message?: string; error?: string };
    throw new Error(body.message ?? body.error ?? `Request failed with HTTP ${response.status}.`);
  }
  return (await response.json().catch(() => ({}))) as T;
}

export async function loadReports(): Promise<PostStreamReport[]> {
  const catalog = await request<{ reports?: PostStreamReport[] }>('/api/v1/foundation/catalog');
  return catalog.reports ?? [];
}

export function generateReport(sessionId?: string): Promise<unknown> {
  return request('/api/v1/foundation/reports/generate', {
    method: 'POST',
    body: JSON.stringify(sessionId ? { sessionId } : {}),
  });
}
